import React from 'react';

export function Dialog({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70">
      <div className="relative bg-slate-900 text-white rounded-lg shadow-2xl w-full max-w-md mx-4 p-0">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-blue-500 text-2xl font-bold z-10"
          aria-label="Close"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}
